import CardSlider from './CardSlider'
export default CardSlider
